import { render, staticRenderFns } from "./ChoiceFieldDisplay.vue?vue&type=template&id=10fc453f&"
import script from "./ChoiceFieldDisplay.vue?vue&type=script&lang=js&"
export * from "./ChoiceFieldDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceFieldDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChoiceFieldDisplay.vue"
export default component.exports